import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import CheckoutContext from '../lib/CheckoutContext';
import { HARDWARE_FIRST_MAX_UNITS_PER_CART, hardwareFirstUnitCount } from '../lib/hardwareFirst';
import * as types from '../types';

/**
 * Hardware-first units in the active checkout cart. Gates the klarna/bnpl
 * options, the free-shipping display, and the per-cart unit cap. Must be called within a
 * CheckoutContextProvider.
 */
export default function useHardwareFirstCartUnits(): number {
  const { cart } = useContext(CheckoutContext);
  const products = useSelector((state: types.AppState) => state.config.products);

  return useMemo(() => hardwareFirstUnitCount(cart, products), [cart, products]);
}

/**
 * Whether the persisted store cart is already at the hardware-first unit cap. For PDP add-to-bag
 * guards, which render outside a CheckoutContextProvider.
 */
export function useHardwareFirstStoreCartAtCap(): boolean {
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);
  const products = useSelector((state: types.AppState) => state.config.products);

  return useMemo(() => hardwareFirstUnitCount(cart, products) >= HARDWARE_FIRST_MAX_UNITS_PER_CART, [cart, products]);
}
